// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2WlhA","error":"InputSecondary_error__6ajz8","disabled":"InputSecondary_disabled__1BKIn"};